import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import { Avatar, Button, Dropdown, MenuProps, Space } from "antd";
import {
  LOCAL_STORAGE_KEY_AUTH,
  USER_LIST_ORDER_MENU_KEY,
  USER_PROFILE_MENU_KEY,
} from "../../../../applications/constants/AppConst";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./styles/index.scss";
import LogoutOutlined from "@ant-design/icons/lib/icons/LogoutOutlined";
import { LoginOutlined, OrderedListOutlined, ProfileOutlined } from "@ant-design/icons";
import usePageState from "../../../hooks/usePageState";

interface Props {
  setActiveMenuNav: (val: number) => void;
}

function HeaderBtnLogin(props: Props) {
  const { setActiveMenuNav } = props;
  const { authData, setAuthData } = useAuth();
  const navigate = useNavigate();
  const { showInfo } = usePageState();

  const handleLogin = () => {
    showInfo("Chúng tôi đang nâng cấp hệ thống đăng nhập. Cảm ơn bạn đã kiên nhẫn chờ đợi!");
    return;
    // setAuthData(null);
    // localStorage.removeItem(LOCAL_STORAGE_KEY_AUTH);
    // navigate("/login");
  };

  const handleLogout = () => {
    setAuthData(null);
    localStorage.removeItem(LOCAL_STORAGE_KEY_AUTH);
    window.location.reload();
  };
  const isLoggedIn = Boolean(authData?.id);

  const userMenuItems: MenuProps["items"] = isLoggedIn
    ? [
        {
          key: "profile",
          label: "Profile",
          icon: <ProfileOutlined />,
          onClick: () => setActiveMenuNav(USER_PROFILE_MENU_KEY),
        },
        {
          key: "List_Orders",
          label: "Đơn hàng",
          icon: <OrderedListOutlined />,
          onClick: () => setActiveMenuNav(USER_LIST_ORDER_MENU_KEY),
        },
        {
          key: "sign_out",
          label: "Đăng xuất",
          icon: <LogoutOutlined />,
          onClick: handleLogout,
        },
      ]
    : [
        {
          key: "sign_in",
          label: "Đăng nhập",
          icon: <LoginOutlined />,
          onClick: handleLogin,
        },
      ];

  return isLoggedIn ? (
    <div className="header-btn">
      <Dropdown menu={{ items: userMenuItems }} trigger={["click"]} placement="bottomRight">
        <Space style={{ cursor: "pointer", height: "40px" }}>
          <Avatar size="small" icon={<UserOutlined />} />
          <span className="user-name"> {authData?.id ? authData.display_name : "Đăng nhập"}</span>
        </Space>
      </Dropdown>
    </div>
  ) : (
    <div className="header-btn" onClick={handleLogin}>
      <Button
        icon={<UserOutlined />}
        style={{
          border: "none",
          fontSize: "18px",
          padding: "4px",
        }}
      />
      <span className="header-btn-action-label">Đăng nhập</span>
    </div>
  );
}

export default HeaderBtnLogin;
